export default defineNuxtRouteMiddleware(() => {
        const { user, isAdmin } = useCredentials()
        if (!user.value) return
        if (isAdmin()) return navigateTo("/admin")
        return navigateTo("/dashboard")
})
